import axios from "axios"; // 引入axios

export default axios;
